import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { Add } from '@material-ui/icons'
import PlanComponent from './PlanComponent'
import AdminToolbarComponent from 'routes/Admin/components/CommonComponents/AdminToolbarComponent'
import SwitchToolbarComponent from 'routes/Admin/components/CommonComponents/SwitchToolbarComponent'
import {
  MODAL_ADMIN_EDIT_TABLE,
  MODAL_ADMIN_CREATE_TABLE,
  MODAL_ADMIN_DELETE_TABLE,
  MODAL_ADMIN_WARNING_IN_USE
} from 'redux/modules/modals'
const propTypes = {
  tables: PropTypes.array.isRequired,
  updateTable: PropTypes.func.isRequired,
  map: PropTypes.object.isRequired,
  updateMapSize: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired
}

class AdminPoolTablesComponent extends Component {
  state = {
    editPlanChecked: false
  }
  handleUpdateMapSize = direction => {
    const delta = 50
    const width = this.props.map.width + delta
    const height = this.props.map.height + delta
    switch (direction) {
      case 'bottom':
        this.props.updateMapSize({
          width: width,
          height: height
        })
        break
      case 'right':
        this.props.updateMapSize({
          width: width,
          height: height
        })
        break
      default:
        break
    }
  }
  handleUpdateTable = (table, changes) => {
    this.props.updateTable(table, changes)
    this.updateMapSize(table)
    if (changes.type) {
      this.setState({ openEdit: false })
    }
  }
  updateMapSize = table => {
    let minX = 0
    let minY = 0
    let maxHorX = 0
    let maxVerX = 0
    let maxHorY = 0
    let maxVerY = 0
    const borderWidth = 30
    const grid = 10
    let widthTable = 200
    let heightTable = 100

    this.props.tables.map(table => {
      if (table.isVertical) {
        if (maxVerX < table.posX) maxVerX = table.posX
        if (maxVerY < table.posY) maxVerY = table.posY
      } else {
        if (maxHorX < table.posX) maxHorX = table.posX
        if (maxHorY < table.posY) maxHorY = table.posY
      }
      minX = minX > table.posX ? table.posX : minX
      minY = minY > table.posY ? table.posY : minY
      return null
    })
    const width =
      maxVerX + heightTable > maxHorX + widthTable
        ? maxVerX + heightTable
        : maxHorX + widthTable
    const height =
      maxHorY + heightTable > maxVerY + widthTable
        ? maxHorY + heightTable
        : maxVerY + widthTable
    const widthUpdated = width + borderWidth + grid
    const heightUpdated = height + borderWidth + grid
    this.props.updateMapSize({
      width: widthUpdated,
      height: heightUpdated
    })
  }
  handleEditMode = isEnabled => {
    this.setState({ editPlanChecked: isEnabled })
  }
  handleCreateTable = () => {
    this.props.showModal(MODAL_ADMIN_CREATE_TABLE)
  }
  handleEditTable = table => {
    if (table.currentTransaction) {
      this.props.showModal(MODAL_ADMIN_WARNING_IN_USE, table)
      return
    }
    this.props.showModal(MODAL_ADMIN_EDIT_TABLE, table)
  }
  handleDeleteTable = table => {
    if (table.currentTransaction) {
      this.props.showModal(MODAL_ADMIN_WARNING_IN_USE, table)
      return
    }
    this.props.showModal(MODAL_ADMIN_DELETE_TABLE, table)
  }
  renderEmptyPlanComponent = () => {
    return (
      <Grid item xs={11} style={{ marginTop: '80px' }}>
        <Paper style={{ minWidth: 380 }}>
          <Grid
            container
            item
            direction="column"
            alignItems="center"
            justify="center"
            spacing={16}>
            <Grid item xs={12}>
              <Typography variant="subheading" gutterBottom>
                Ajouter votre première table
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={this.handleCreateTable}
                variant="fab"
                color="secondary"
                aria-label="add">
                <Add color="inherit" />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }
  render() {
    const { tables, map } = this.props
    return (
      <Grid
        container
        direction="column"
        alignContent="stretch"
        alignItems="stretch"
        spacing={0}>
        <Grid
          style={{ position: 'absolute', left: 0, right: 0, zIndex: 1100 }}
          item
          xs={12}>
          <AdminToolbarComponent
            title="Gestion du plan de salle"
            createAction={this.handleCreateTable}>
            <SwitchToolbarComponent
              checked={this.state.editPlanChecked}
              onChange={this.handleEditMode}
              label="Activer la modification"
            />
          </AdminToolbarComponent>
        </Grid>
        <Grid
          container
          item
          direction="column"
          alignContent="stretch"
          alignItems="center"
          justify="center"
          spacing={16}>
          {tables.length > 0 ? (
            <Grid
              item
              xs={11}
              style={{ marginTop: '80px', overflow: 'scroll' }}>
              <PlanComponent
                toggled={this.state.editPlanChecked}
                tables={tables}
                map={map}
                size="medium"
                updateMapSize={this.handleUpdateMapSize}
                deleteTable={this.handleDeleteTable}
                updateTable={this.handleUpdateTable}
                editTable={this.handleEditTable}
              />
            </Grid>
          ) : (
            this.renderEmptyPlanComponent()
          )}
        </Grid>
      </Grid>
    )
  }
}

AdminPoolTablesComponent.propTypes = propTypes
export default AdminPoolTablesComponent



// WEBPACK FOOTER //
// ./src/routes/Admin/Tables/components/AdminPoolTablesComponent.js